import {CasinoLegacyDeepLinkActionBase} from "../casino-legacy-deep-link-action-base";
import {
    AppIdentifiers,
    AreaType,
    ControlCenterDeeplink,
    ControlCenterOpenSource,
    IControlCenterFullSpecificParams,
    TriggerType
} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {Check} from "@sparkware/app-utils";

export class ControlCenterDeeplinkAction extends CasinoLegacyDeepLinkActionBase {
  async execute() {

    let params = this._extractParams(this.descriptor.actionParams?.id);

    await this.services.messageBroker.channels.performAction.topics.openControlCenterFull.execute({
        launchInfo: {
            businessCorrelationID: this.services.tools.getGuid(),
            channel: {
                area: AreaType.externalClick,
                element: CHANNEL_ELEMENTS.deepLink,
                source: CHANNEL_SOURCE.casinoClient
            },
            appSpecificParameters: {
                source: ControlCenterOpenSource.Lobby,
                ...params
            },
            sourceAppVersion: this.services.sdk.getSkin().getVersion(),
            sourceAppID: AppIdentifiers.CasinoClient,
            trigger: TriggerType.automaticFlow
        }
    });
      await this._executeNextAction();
  }

  private _extractParams(params: string | number | undefined | null): Partial<IControlCenterFullSpecificParams> {
      if(Check.isEmpty(params)) {
          return {
              deeplink: ControlCenterDeeplink.Main
          };
      }
      if(Check.isNumber(params)) {
          return {
              deeplink: params
          };
      }

      const splittedParams = params.split('|');

      let deeplink = parseInt(splittedParams[0]);
      if(!Check.isNumber(deeplink)) {
          deeplink = ControlCenterDeeplink.Main;
      }

      let isIncreaseLimitsDisabled = splittedParams[1]?.toLowerCase() === 'true';
      return {
          deeplink: deeplink,
          isIncreaseLimitsDisabled: isIncreaseLimitsDisabled
      };

  }
}
